import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import {
  DefaultValues,
  FieldValues,
  UseFormProps,
  UseFormReturn,
  useForm as useReactHookForm,
} from 'react-hook-form';

type Props<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
> = UseFormProps<TFieldValues, TContext>;

export const useForm = <
  TFieldValues extends FieldValues = FieldValues,
  TTransformedValues extends FieldValues | undefined = undefined,
  TContext = unknown,
>({
  defaultValues,
  delayError = 1000,
  ...props
}: Props<TFieldValues, TContext>): UseFormReturn<
  TFieldValues,
  TContext,
  TTransformedValues
> => {
  const form = useReactHookForm<TFieldValues, TContext, TTransformedValues>({
    ...props,
    delayError,
    defaultValues,
  });
  useEffect(() => {
    if (
      defaultValues &&
      !isEqual(defaultValues, form.formState.defaultValues)
    ) {
      form.reset(defaultValues as DefaultValues<TFieldValues>);
    }
  }, [form, defaultValues]);

  return form;
};
